var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeProtectionWarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 14v52H50v-4h12V18H50v-4h16zM51.94 27.06l-5.54 6.55 5.71 6.76-5.71 6.75 4.92 5.82h3.93l-4.92-5.82L56 40.37l-5.71-6.76 5.54-6.55h-3.89zm-4.7 13.31l-5.71-6.76 5.54-6.55h-3.93l-5.54 6.55 5.71 6.76-5.71 6.75 1.4 1.62 3.55 4.2h3.93l-4.92-5.82 5.68-6.75zm-8.79 0l-5.72-6.76 5.55-6.55h-3.93l-5.55 6.55 5.72 6.76-5.72 6.75 4.93 5.82h3.93l-4.93-5.82 5.72-6.75zm-14.52 6.75l5.72-6.75-5.72-6.76 5.55-6.55h-3.93L20 33.61l5.72 6.76L20 47.12l4.93 5.82h3.93l-.63-.75-4.3-5.07zM14 18h12v-4H10v52h16v-4H14V18z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_protection_warm.59cf6f09.svg";
export { SvgF1ModeProtectionWarm as ReactComponent };